// Builders for schema.org structured data (JSON-LD) used across pages.
import { company, services } from '../data/site';

export const SITE_URL = 'https://fedigmaforge.com';

const absolute = (path) => `${SITE_URL}${path === '/' ? '' : path}`;

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#organization`,
  name: company.name,
  legalName: company.legalName,
  alternateName: 'Fedigma Forge',
  slogan: company.tagline,
  description: company.summary,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  image: `${SITE_URL}/logo.png`,
  email: company.email,
  telephone: company.phones[0].display.replace(/\s/g, ''),
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'D 60/61 Sewak Park, Dwarka',
    addressLocality: 'New Delhi',
    addressRegion: 'Delhi',
    addressCountry: 'IN'
  },
  areaServed: { '@type': 'Country', name: 'India' },
  sameAs: Object.values(company.socials),
  knowsAbout: [
    'School website design',
    'School ERP software',
    'Coaching institute marketing',
    'Educational content writing',
    'Career counselling',
    'Digital classroom setup',
    'Social media management for schools'
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Digital services for educational institutions',
    itemListElement: services.map((service) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name: service.title, url: absolute(service.link) }
    }))
  }
});

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  name: company.name,
  url: SITE_URL,
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: 'en-IN'
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: absolute(item.path)
  }))
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer }
  }))
});

export const serviceSchema = ({ name, description, path, audience }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  url: absolute(path),
  serviceType: name,
  provider: { '@id': `${SITE_URL}/#organization` },
  areaServed: { '@type': 'Country', name: 'India' },
  audience: { '@type': 'EducationalAudience', educationalRole: audience || 'educational institutions' }
});

export const articleSchema = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: post.title,
  description: post.excerpt,
  datePublished: post.date,
  dateModified: post.date,
  author: { '@type': 'Organization', name: post.author },
  publisher: { '@id': `${SITE_URL}/#organization` },
  mainEntityOfPage: absolute(`/blog/${post.slug}`),
  image: `${SITE_URL}/logo.png`,
  articleSection: post.category,
  inLanguage: 'en-IN'
});
